var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vector", _vm._b({}, "vector", _vm.$props, false), [
    _c("g", { attrs: { opacity: "0.5" } }, [
      _c("path", {
        staticClass: "clouds-1",
        attrs: {
          d:
            "M-.46,274.18C7.66,242,33.69,263.7,52.39,251.3c5.4-4.27,2.3-7.44,9.2-14.42,8.11-8.22,18.71-10.9,23.74-11.77,12.77-2.21,16.39,2.62,21.55-1.06,7.14-5.09,1.11-16,8.17-28.33,11.89-18.78,41.66-34.88,72.47-22.89,9.49,4.62,12.74,10.89,18,9.27,6.64-2.06,4.14-12.93,12.54-23.43,18.58-19.21,44.53-17.24,66.47-13.08,5-1.16,55.47,19.17,65.39,9.81,1.91-53.79,89.48-107,147.66-81.73,7.06,2.9,12.76,6.54,19.61,4.35C544,59.31,517.51,18,594,.11V272"
        }
      }),
      _c("path", {
        staticClass: "clouds-1",
        attrs: {
          d:
            "M1188.46,274.18c-8.12-32.18-34.15-10.48-52.85-22.88-5.4-4.27-2.3-7.44-9.2-14.42-8.11-8.22-18.71-10.9-23.74-11.77-12.77-2.21-16.39,2.62-21.55-1.06-7.14-5.09-1.11-16-8.17-28.33-11.89-18.78-41.66-34.88-72.47-22.89-9.49,4.62-12.74,10.89-18,9.27-6.64-2.06-4.14-12.93-12.54-23.43-18.58-19.21-44.53-17.24-66.47-13.08-5-1.16-55.47,19.17-65.39,9.81-1.91-53.79-89.48-107-147.66-81.73-7.06,2.9-12.76,6.54-19.61,4.35C644,59.31,670.49,18,594,.11V272"
        }
      }),
      _c("path", {
        staticClass: "clouds-1",
        attrs: {
          d:
            "M-.08,440.17c0-9.89,11.5-19.17,19.31-19.07,11.16-.59,15.3,3.81,19.56-7.08,4.57-7.34,13.89-12.93,22.52-13.44,7.5-.44,10.21,3.21,14.53.73s2.75-6.48,7.26-10.54c6.22-5.59,15.91-4.13,16.71-4,8.75,1.44,10.11,7.41,16.71,6.9,4.47-.35,4.87-3.17,12.35-7.27a46.41,46.41,0,0,1,18.89-5.81c4.09-.3,13-.94,21.23,4,5.5,3.28,6.56,6.57,10.74,6.57,3.86,0,4.09-2.79,11.53-5a63.91,63.91,0,0,1,9.54-1.9c9.74.29,11.76-5.17,15.62-9.8,6.23-4.79,15.11-11.61,26.42-15.11,16.92-5.25,21.81,2.35,37.15-1.6,14.13-3.65,13.17-10.92,27.6-18.53,28.06-14.8,62.77-.12,83.9-4.52A65.45,65.45,0,0,1,403.85,333c8.66-.3,9.46,1.48,13.44.36,6.33-1.78,10.47-6.81,15.62-13.44,5.62-7.23,4.25-8.32,8-11.26,0,0,3.74-2.52,22.36-2.51q.25,62.82.52,125.65Z"
        }
      }),
      _c("path", {
        staticClass: "clouds-1",
        attrs: {
          d:
            "M927.79,440.17c0-9.89-11.51-19.17-19.32-19.07-11.15-.59-15.29,3.81-19.55-7.08-4.57-7.34-13.89-12.93-22.52-13.44-7.51-.44-10.22,3.21-14.53.73s-2.76-6.48-7.27-10.54c-6.22-5.59-15.91-4.13-16.71-4-8.75,1.44-10.11,7.41-16.71,6.9-4.47-.35-4.87-3.17-12.35-7.27a46.41,46.41,0,0,0-18.89-5.81c-4.08-.3-13-.94-21.22,4-5.51,3.28-6.57,6.57-10.74,6.57-3.87,0-4.09-2.79-11.54-5a64.07,64.07,0,0,0-9.53-1.9c-9.75.29-11.76-5.17-15.62-9.8-6.23-4.79-15.12-11.61-26.42-15.11-16.93-5.25-21.81,2.35-37.15-1.6-14.13-3.65-13.18-10.92-27.61-18.53-28.06-14.8-62.76-.12-83.9-4.52A65.18,65.18,0,0,0,523.85,333c-8.66-.3-9.45,1.48-13.44.36-6.33-1.78-10.46-6.81-15.62-13.44-5.62-7.23-4.24-8.32-8-11.26,0,0-3.74-2.52-22.37-2.51h0l-.51,125.65Z"
        }
      }),
      _c("path", {
        staticClass: "clouds-1",
        attrs: {
          d:
            "M163.79,43.9C162,40,158.91,34.81,153.44,32.73c-5.14-1.95-6.68.73-11.17-1.36-6.06-2.82-5.93-8.79-13.89-12.53-.38-.18-.74-.34-1.09-.47a23.89,23.89,0,0,0-2.73-.89c-11.38-3-16.62-2.46-16.62-2.46-5.09.5-9.91,2.42-11,.69-.14-.23-.21-.46-.63-1.37a19.36,19.36,0,0,0-1.72-2.86c-3-4.26-6-8.55-10.73-10.26-5.74-2.06-13,0-17.6,3.18-2.63,1.85-3.69,3.63-6,3.54-3.26-.13-4-4.26-7.63-5.18C47.18,1.4,41.9,5,40.38,6c-9.19,6.27-6.84,14.65-15.26,18.53a64,64,0,0,0-8.44,3.81,36.26,36.26,0,0,0-6,4.09C5.94,36.72,4.39,42.94,3.87,47.17Z"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }